import React from "react";
import { Container, Modal } from "reactstrap";

import Btn from "./Button";

const InfoModal = ({ message, onConfirm, confirmLabel }) => {
  return (
    <Modal centered={true} isOpen={!!message}>
      <Container className="confirm-modal">
        <div className="confirm-modal-title">{message}</div>
        <div className="confirm-modal-buttons">
          {confirmLabel && (
            <Btn label={confirmLabel} type={"button"} onClick={onConfirm} />
          )}
        </div>
      </Container>
    </Modal>
  );
};

export default InfoModal;
